import React from 'react'

export default class IconsAlignMiddle extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color

        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                style={this.props.style}
            >
                <g>
                    <path
                        d='M9.99997 1.334H5.99996C5.26356 1.334 4.66663 1.93093 4.66663 2.66733V4.00067C4.66663 4.73707 5.26356 5.334 5.99996 5.334H9.99997C10.73637 5.334 11.3333 4.73707 11.3333 4.00067V2.66733C11.3333 1.93093 10.73637 1.334 9.99997 1.334Z'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M11.33337 10.66602H4.6667C3.9303 10.66602 3.33337 11.26295 3.33337 11.99935V13.33269C3.33337 14.06909 3.9303 14.66602 4.6667 14.66602H11.33337C12.06977 14.66602 12.6667 14.06909 12.6667 13.33269V11.99935C12.6667 11.26295 12.06977 10.66602 11.33337 10.66602Z'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M14.6673 8H1.33398'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
            </svg>
        )
    }
}
